import "jquery-ui";
import {currentBrowser, createEventListener, parseBool} from "./tools";
import Request from "./request";

const modulesOrder = ['', 'information', 'episode', 'episodes', 'episodeFavorite', 'comment', 'question', 'info', 'information', 'twitter', 'search', 'table', 'compact-close', 'episodeFavorite', 'activity'];

const getModuleOrder = ($app, name) => {
    if (name === 'comment' && $app.event().moduleComment.order() > 0) {
        return $app.event().moduleComment.order() - 1;
    }
    if (name === 'question' && $app.event().moduleQuestion.order() > 0) {
        return $app.event().moduleQuestion.order() - 1;
    }

    return modulesOrder.indexOf(name);
}

export default function ($app) {
	const self = this;

	self.tabHandler = {};
	self.tab = {
		all: ko.observableArray()
	};
	self.button = {
		all: ko.observableArray()
	};
	self.tab.right = ko.computed(function() {
		return self.tab.all().filter(function(module) {
			return module.position() === 'right' && !currentBrowser.isMobile();
		});
	});
	self.button.right = ko.computed(function() {
		return self.button.all().filter(function(button) {
			return button.position() === 'right' && !currentBrowser.isMobile();
		});
	});
	self.tab.bottom = ko.computed(function() {
		return self.tab.all().filter(function(module) {
			return module.position() === 'bottom' || currentBrowser.isMobile();
		});
	});
	self.button.bottom = ko.computed(function() {
		return self.button.all().filter(function(button) {
			return button.position() === 'bottom' || currentBrowser.isMobile();
		});
	});
	self.currentHint = ko.observable();

	$app.on('start', function() {
		setTimeout(function() {
			['right', 'bottom'].forEach(function(position) {
				const container = $('#' + position + 'Container');
				container.tabs({
					hide: 'fade',
					show: 'fade',
					activate: function() {
						const tabNumber = container.tabs('option', 'active');
						const module = self.tab[position]()[tabNumber];
						const tabHandler = self.tabHandler[module.name];
						if(tabHandler) {
							tabHandler.trigger('open');
						} else {
							console.error('Cant fint ui.tab module handler');
						}
					}
				});

				self.tab[position].subscribe(function() {
//				container.tabs('refresh');
				});
			});
		}, 0);
	});

	self.hasContainer = function(position) {
		switch(position) {
			case 'right': return (self.tab.right().length) > 0;
			case 'bottom': return (self.tab.bottom().length) > 0;
		}
		return false;
	};

	self.Tab = function(module) {
		const tab = this;

		tab.type = 'tab';
		tab.module = module;
		tab.isShow = ko.observable(true);
		tab.name = module.name;
		tab.icon = module.icon || module.name;
		tab.position = module.position;
		tab.title = ko.isObservable(module.title) ? module.title : ko.observable(module.title);
		tab.order = getModuleOrder($app, module.name);
		tab.isShowHint = ko.observable(false);

		createEventListener(tab);

		tab.open = function() {};

		tab.showHint = function() {
			if(self.currentHint()) {
				self.currentHint().hideHint();
			}
			tab.isShowHint(true);
			self.currentHint(tab);
			return tab;
		};
		tab.hideHint = function() {
			tab.isShowHint(false);
			return tab;
		};

		self.tab.all.push(tab);
		self.tab.all.sort(function(a, b) { return a.order - b.order; });
		self.tabHandler[tab.name] = tab;
	};

	self.Button = function(module) {
		const button = this;

		button.type = 'button';
		button.isShow = ko.observable(true);
		button.name = module.icon;
		button.icon = module.icon;
		button.position = module.position;
		button.title = ko.isObservable(module.title) ? module.title : ko.observable(module.title);
		button.order = getModuleOrder($app, module.icon);
		button.isShowHint = ko.observable(false);
        button.isShowTitle = ko.isObservable(module.isShowTitle) ? module.isShowTitle : ko.observable(module.isShowTitle || false);

		createEventListener(button);

		button.click = function() { button.trigger('click'); };

		button.showHint = function() {
			if(self.currentHint()) {
				self.currentHint().hideHint();
			}
			button.isShowHint(true);
			self.currentHint(button);
			return button;
		};
		button.hideHint = function() {
			button.isShowHint(false);
			return button;
		};

		self.button.all.push(button);
		self.button.all.sort(function(a, b) { return a.order - b.order; });
//		self.tab.all.push(button);
//		self.tab.all.sort(function(a, b) { return a.order - b.order; });
		self.tabHandler[button.name] = button;
	};

	self.updateContainer = function() {
		let pageHeight = 0;
		const playerContainer = $('#playerContainer');
		const bannerContainer = $('#bannerContainer');
		//const topModules = $('#topModules');
		const bottomModules = $('#bottomModules');

		switch($app.page()) {
			case 'player':
				bottomModules.height(500);
				pageHeight = playerContainer.height();
				pageHeight += $app.event().banner().length ? bannerContainer.height() : 0;
				pageHeight += self.hasContainer('bottom') ? bottomModules.height() : 0;
			break;

			case 'login':
				pageHeight = $('#login-page').outerHeight() + 10;
			break;

			default: return;
		}

		parent.postMessage(JSON.stringify({setHeight: pageHeight}), '*');

		return this;
	};

	self.playerSize = new function() {
		const playerSize = this;

		playerSize.isExpanded = ko.observable(false);
		playerSize.isCompact = ko.observable(false);
		playerSize.isCompactShow = ko.observable(false);
		playerSize.isFullScreen = ko.observable(false);

		const closeButton  = new self.Button({
			position: ko.observable('right'),
			icon: 'compact-close'
		});
		closeButton.isShow = playerSize.isCompactShow;
		closeButton.on('click', function() { playerSize.isCompactShow(false); });

		createEventListener(this);

		ko.computed(function() {
			$('body')
				.toggleClass('bigPlayer', playerSize.isExpanded() && self.hasContainer('right'))
				.toggleClass('compactPlayer', playerSize.isCompact() && self.hasContainer('right'))
				.toggleClass('compactPlayerShow', (playerSize.isCompact() || playerSize.isExpanded()) && playerSize.isCompactShow() && self.hasContainer('right'))
			;
			self.updateContainer();
		});

		playerSize.set = function(size) {
			playerSize.isExpanded(size === 'max');
			return playerSize;
		};

		playerSize.toggle = function() {
			playerSize.isExpanded(!playerSize.isExpanded());
			return playerSize;
		};

		playerSize.check = function() {
			const minWidth = 849;
			if(Request.params.compactPlayer && parseBool(Request.params.compactPlayer) && self.tab.right().length) {
				playerSize.isCompact(true);
			} else if($(window).width() <= minWidth && self.tab.right().length) {
				playerSize.isCompact(true);
			} else {
				playerSize.isCompact(false);
			}
		};

		$(document).on('fullscreenchange', function() {
			playerSize.isFullScreen(!!$(document).fullScreenElement());
		});
		$(window).resize(function() { playerSize.check(); });
		$app.on('start', function() { setTimeout(function() { playerSize.check(); }, 0); });
	};

	window.playerSize = function(size) { self.playerSize.set(size); };
	$(document).on("fullscreenchange", function() {
		const $body = $('body');
		$(document).fullScreenElement() ? $body.addClass('fullScreen') : $body.removeClass('fullScreen');
        self.updateContainer();
	});

	$(window).resize(function() {
		self.updateContainer();
	});
	$app.on('start', function() { setTimeout(function() { self.updateContainer(); }, 0); });

	if(Request.params['hideFooter']) { $('.bottomContent').hide(); }

}
